import { render, staticRenderFns } from "./ItemCardReplacedBy.vue?vue&type=template&id=58ec8d14&scoped=true"
import script from "./ItemCardReplacedBy.vue?vue&type=script&lang=ts"
export * from "./ItemCardReplacedBy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec8d14",
  null
  
)

export default component.exports